const styles = (theme) => ({
  root: {
    minHeight: "100vh",
    position: "relative",
    backgroundColor: theme.palette.primary.lightBg,
  },

  container: {
    flexGrow: 1,
    height: "auto",
    backgroundColor: theme.palette.primary.lightBg,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    position: "relative",
  },
});

export default styles;
